// Starting a call from the bottom-nav coach: a copy of the face grows from the
// avatar to full screen and fades once the call view (same photo) is underneath.
// It covers the call view while it mounts, so there's no flash between the two.
const GROW_MS = 420
const HOLD_MS = 260
const FADE_MS = 280

export function launchCallFrom(el: Element | null) {
  if (!el || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  const media = el.querySelector('img, video') as HTMLImageElement | HTMLVideoElement | null
  const src = media instanceof HTMLVideoElement ? media.poster : media?.currentSrc || media?.src
  const b = el.getBoundingClientRect()
  const ghost = document.createElement('div')
  ghost.setAttribute('aria-hidden', 'true')
  Object.assign(ghost.style, {
    position: 'fixed',
    left: '0',
    top: '0',
    width: '100vw',
    height: '100dvh',
    zIndex: '70',
    pointerEvents: 'none',
    background: src ? `center / cover no-repeat url("${src}")` : 'var(--muted)',
    willChange: 'left, top, width, height, border-radius, opacity',
  })
  document.body.appendChild(ghost)
  const grow = ghost.animate(
    [
      {
        left: `${b.left}px`,
        top: `${b.top}px`,
        width: `${b.width}px`,
        height: `${b.height}px`,
        borderRadius: `${b.width / 2}px`,
      },
      { left: '0px', top: '0px', width: '100vw', height: '100dvh', borderRadius: '0px' },
    ],
    { duration: GROW_MS, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' },
  )
  void grow.finished
    .then(
      () =>
        ghost.animate([{ opacity: 1 }, { opacity: 0 }], {
          duration: FADE_MS,
          delay: HOLD_MS,
          fill: 'forwards',
        }).finished,
    )
    .catch(() => {})
    .finally(() => ghost.remove())
}
